/**
  * v0.0.2
  * (c) 2023 traveller platform
  */
import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { $colorTextPlaceholder, $colorAccent10, $colorAccent8, $colorTextPrimary } from '@klook/klook-ui/lib/utils/design-token-esm';
import IconChevronDown from '@klook/klook-icons/lib/IconChevronDown';
import IconNext from '@klook/klook-icons/lib/IconNext';
import transformImageUrl from '@klook/klk-traveller-utils/lib/transformImageUrl';
import KlkButton from '@klook/klook-ui/lib/button/index';
import KlkBottomSheet from '@klook/klook-ui/lib/bottom-sheet/index';
import KlkPoptip from '@klook/klook-ui/lib/poptip/index';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var CommonMixin = /** @class */function (_super) {
  __extends(CommonMixin, _super);
  function CommonMixin() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.defaultPoptipOptions = {
      width: 400,
      'max-width': 400,
      'max-height': 550
    };
    return _this;
  }
  Object.defineProperty(CommonMixin.prototype, "_inhouse", {
    get: function get() {
      return (this === null || this === void 0 ? void 0 : this.inhouse) || (this === null || this === void 0 ? void 0 : this.$inhouse) || typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.inhouse) || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "creditInfo", {
    get: function get() {
      return this.memberCreditInfo || {};
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "levelType", {
    get: function get() {
      var _a;
      var mapType = {
        '-1': 'Visitor',
        0: 'Lv1',
        1: 'Lv2'
      };
      return mapType[(_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.level] || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "componentStyle", {
    get: function get() {
      var _a, _b;
      return ((_b = (_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.style) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "membershipResidence", {
    get: function get() {
      var _a;
      return ((_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.membership_residence) || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "confirmedResidence", {
    get: function get() {
      var _a;
      return ((_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.confirmed_residence) || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "rebateRate", {
    get: function get() {
      var _a = this.creditInfo.rebate_rate_multiplier,
        rebate_rate_multiplier = _a === void 0 ? 0 : _a;
      return rebate_rate_multiplier;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "is3X", {
    get: function get() {
      return this.rebateRate === 3;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "creditRate", {
    // 积分总数
    get: function get() {
      return this.rebateRate * this.credit || 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "componentData", {
    get: function get() {
      var _a;
      return ((_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.component[this.componentStyle]) || {};
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "countDesc", {
    get: function get() {
      var _a;
      return ((_a = this.componentData) === null || _a === void 0 ? void 0 : _a.count_desc) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "valueDesc", {
    get: function get() {
      var _a;
      return ((_a = this.componentData) === null || _a === void 0 ? void 0 : _a.value_desc) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "subDesc", {
    get: function get() {
      var _a;
      return ((_a = this.componentData) === null || _a === void 0 ? void 0 : _a.sub_desc) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "realWebp", {
    get: function get() {
      var _a, _b, _c;
      if (this.webp !== undefined) {
        return this.webp;
      }
      return ((_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.$store) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.klook) === null || _c === void 0 ? void 0 : _c.webp) || 0;
    },
    enumerable: false,
    configurable: true
  });
  CommonMixin.prototype.formatPicUrl = function (url, _a) {
    var width = _a.width,
      height = _a.height;
    return transformImageUrl(url, {
      width: width,
      height: height,
      webp: this.realWebp
    });
  };
  CommonMixin.prototype.roundAndKeepDigits = function (num, digits) {
    return Math.round(num * Math.pow(10, digits)) / Math.pow(10, digits);
  };
  Object.defineProperty(CommonMixin.prototype, "currencyLabelMobile3XIcon", {
    get: function get() {
      return this.formatPicUrl('https://res.klook.com/image/upload/v1695191592/UED_new/Platform/platform_credits_2309/img_gold_s_3x.png', {
        width: 96,
        height: 60
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "currencyLabelDesktop3XIcon", {
    get: function get() {
      return this.formatPicUrl('https://res.klook.com/image/upload/v1695191592/UED_new/Platform/platform_credits_2309/img_gold_m_3x.png', {
        width: 102,
        height: 72
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CommonMixin.prototype, "currencyCard3XIcon", {
    get: function get() {
      return this.formatPicUrl('https://res.klook.com/image/upload/v1695191592/UED_new/Platform/platform_credits_2309/img_gold_l_3x.png', {
        width: 120,
        height: 96
      });
    },
    enumerable: false,
    configurable: true
  });
  CommonMixin.prototype.updateDataSpm = function (type, elementSelector, dataSpmString) {
    var selector = this.$el.querySelector(elementSelector);
    selector && selector.setAttribute(type, "".concat(dataSpmString || ''));
  };
  CommonMixin.prototype.sendDataSpm = function (type, elementSelector, customExtra) {
    var inhouse = this._inhouse;
    setTimeout(function () {
      inhouse && inhouse.track(type, elementSelector, customExtra);
    }, 0);
  };
  __decorate([Prop({
    "default": 0
  })], CommonMixin.prototype, "credit", void 0);
  __decorate([Prop({
    "default": null
  })], CommonMixin.prototype, "memberCreditInfo", void 0);
  __decorate([Prop({
    "default": true
  })], CommonMixin.prototype, "visibleRewardEntry", void 0);
  __decorate([Prop({
    type: Number,
    "default": undefined
  })], CommonMixin.prototype, "webp", void 0);
  __decorate([Prop({
    "default": 'desktop'
  })], CommonMixin.prototype, "platform", void 0);
  __decorate([Prop()], CommonMixin.prototype, "inhouse", void 0);
  __decorate([Prop({
    type: Number,
    "default": 10
  })], CommonMixin.prototype, "visibleMinCredit", void 0);
  CommonMixin = __decorate([Component({})], CommonMixin);
  return CommonMixin;
}(Vue);

var NormalCreditValue = /** @class */function (_super) {
  __extends(NormalCreditValue, _super);
  function NormalCreditValue() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(NormalCreditValue.prototype, "isMemberArea", {
    get: function get() {
      var _a;
      return ((_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.level) != -1;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "colorTextPlaceholder", {
    get: function get() {
      return $colorTextPlaceholder;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "rewardsEntryDesc", {
    get: function get() {
      var _a;
      return (_a = this.componentData) === null || _a === void 0 ? void 0 : _a.rewards_entry_desc;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "creditEntry3XIcon", {
    get: function get() {
      return this.formatPicUrl('https://res.klook.com/image/upload/v1694506194/cvsbkp4rijfttoeo2fss.png', {
        width: 64,
        height: 52
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "rewardLink", {
    get: function get() {
      var _a;
      return ((_a = this.componentData) === null || _a === void 0 ? void 0 : _a.rewards_entry_deeplink) || 'javascript:void(0)';
    },
    enumerable: false,
    configurable: true
  });
  NormalCreditValue.prototype.created = function () {};
  __decorate([Prop({
    "default": null
  })], NormalCreditValue.prototype, "memberCreditInfo", void 0);
  __decorate([Prop({
    "default": true
  })], NormalCreditValue.prototype, "visibleRewardEntry", void 0);
  __decorate([Prop({
    type: Number,
    "default": undefined
  })], NormalCreditValue.prototype, "webp", void 0);
  NormalCreditValue = __decorate([Component({
    components: {
      IconNext: IconNext
    }
  })], NormalCreditValue);
  return NormalCreditValue;
}(CommonMixin);

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = NormalCreditValue;
/* template */
var __vue_render__ = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.visibleRewardEntry && !_vm.is3X && _vm.isMemberArea ? _c('a', {
    staticClass: "reward-entry-box",
    attrs: {
      "href": _vm.rewardLink,
      "target": "_blank",
      "data-spm-module": "Get3XCredits",
      "data-spm-virtual-item": "__virtual"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: _vm.creditEntry3XIcon,
      expression: "creditEntry3XIcon"
    }],
    staticClass: "credit_3x_entry_icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "entry_text"
  }, [_vm._v(_vm._s(_vm.rewardsEntryDesc))]), _vm._v(" "), _c('IconNext', {
    attrs: {
      "theme": "outline",
      "size": "16",
      "fill": _vm.colorTextPlaceholder
    }
  })], 1) : _vm._e();
};
var __vue_staticRenderFns__ = [];

/* style */
var __vue_inject_styles__ = undefined;
/* scoped */
var __vue_scope_id__ = "data-v-679dcbac";
/* module identifier */
var __vue_module_identifier__ = undefined;
/* functional template */
var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var NormalCreditValue$1 = /** @class */function (_super) {
  __extends(NormalCreditValue, _super);
  function NormalCreditValue() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(NormalCreditValue.prototype, "currencyDesc", {
    get: function get() {
      var _a = this.creditInfo,
        currency_desc = _a.currency_desc,
        _b = _a.credit_unit_price,
        credit_unit_price = _b === void 0 ? 0 : _b,
        _c = _a.currency_frac,
        currency_frac = _c === void 0 ? 0 : _c;
      var defaultText = currency_desc;
      var defaultPrice = credit_unit_price * this.creditRate;
      return defaultText.replace('{price}', this.roundAndKeepDigits(defaultPrice, currency_frac));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "creditDesc", {
    // 积分总数描述
    get: function get() {
      var credit_desc = this.creditInfo.credit_desc;
      return "".concat(this.creditRate, " ").concat(credit_desc);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "baseCurrencyDesc", {
    get: function get() {
      var _a = this.creditInfo,
        currency_desc = _a.currency_desc,
        _b = _a.credit_unit_price,
        credit_unit_price = _b === void 0 ? 0 : _b,
        _c = _a.currency_frac,
        currency_frac = _c === void 0 ? 0 : _c;
      var defaultText = currency_desc;
      var defaultPrice = credit_unit_price * this.credit;
      return defaultText.replace('{price}', this.roundAndKeepDigits(defaultPrice, currency_frac));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "baseCreditDesc", {
    // 基础积分总数
    get: function get() {
      var credit_desc = this.creditInfo.credit_desc;
      return "".concat(this.credit, " ").concat(credit_desc);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "getCreditDesc", {
    get: function get() {
      var _a;
      return ((_a = this.componentData) === null || _a === void 0 ? void 0 : _a.get_credit_desc) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "supposeCreditDesc", {
    get: function get() {
      var _a;
      return ((_a = this.componentData) === null || _a === void 0 ? void 0 : _a.suppose_credit_desc) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "goldIconText", {
    get: function get() {
      var _a;
      return ((_a = this.componentData) === null || _a === void 0 ? void 0 : _a.gold_icon_text) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "goldMemberLogo", {
    get: function get() {
      return this.formatPicUrl('https://res.klook.com/image/upload/v1695373880/gauu4v7oqudvrhcga4g2.png', {
        width: 55,
        height: 49
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "credit3XRateIcon", {
    get: function get() {
      return this.formatPicUrl('https://res.klook.com/image/upload/v1697192116/kcwuupbymkvavq282rcl.png', {
        width: 120,
        height: 96
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "credit3XRateUpIcon", {
    get: function get() {
      return this.formatPicUrl('https://res.klook.com/image/upload/v1694601358/y8lvyjqqwectpt2v9gug.png', {
        width: 34,
        height: 48
      });
    },
    enumerable: false,
    configurable: true
  });
  NormalCreditValue.prototype.created = function () {};
  __decorate([Prop({
    "default": 0
  })], NormalCreditValue.prototype, "credit", void 0);
  __decorate([Prop({
    "default": 'creditValue'
  })], NormalCreditValue.prototype, "type", void 0);
  __decorate([Prop({
    "default": null
  })], NormalCreditValue.prototype, "memberCreditInfo", void 0);
  __decorate([Prop({
    type: Number,
    "default": undefined
  })], NormalCreditValue.prototype, "webp", void 0);
  NormalCreditValue = __decorate([Component({
    components: {}
  })], NormalCreditValue);
  return NormalCreditValue;
}(CommonMixin);

/* script */
var __vue_script__$1 = NormalCreditValue$1;
/* template */
var __vue_render__$1 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "gold-credit-value-box"
  }, [_c('div', {
    staticClass: "count_desc"
  }, [_vm._v("\n    " + _vm._s(_vm.type === 'credit' ? _vm.countDesc : _vm.valueDesc) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "credit_calculate-content"
  }, [_c('div', {
    staticClass: "credit_calculate_total"
  }, [_c('div', {
    staticClass: "credit_calculate_total_left"
  }, [_c('div', {
    staticClass: "gold_member_logo"
  }, [_c('div', {
    staticClass: "gold_member_logo_icon",
    style: {
      backgroundImage: "url(" + _vm.goldMemberLogo + ")"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gold_member_logo_text"
  }, [_vm._v(_vm._s(_vm.goldIconText))])]), _vm._v(" "), _c('span', {
    staticClass: "earn_text"
  }, [_vm._v(_vm._s(_vm.getCreditDesc))])]), _vm._v(" "), _c('div', {
    staticClass: "credit_calculate_total_right"
  }, [_vm.type === 'credit' ? [_c('span', {
    staticClass: "credit_value_text"
  }, [_vm._v(_vm._s(_vm.creditRate))]), _vm._v(" "), _c('span', {
    staticClass: "credit_text"
  }, [_vm._v("(≈ " + _vm._s(_vm.currencyDesc) + ")")])] : [_c('span', {
    staticClass: "credit_value_text"
  }, [_vm._v("≈ " + _vm._s(_vm.currencyDesc))]), _vm._v(" "), _c('span', {
    staticClass: "credit_text"
  }, [_vm._v("(" + _vm._s(_vm.creditDesc) + ")")])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "rate_credit_icon"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: _vm.credit3XRateIcon,
      expression: "credit3XRateIcon"
    }],
    staticClass: "credit_3x_rate_icon"
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: _vm.credit3XRateUpIcon,
      expression: "credit3XRateUpIcon"
    }],
    staticClass: "credit_3x_up_icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "credit_calculate_base"
  }, [_c('div', {
    staticClass: "credit_calculate_base_left"
  }, [_vm._v(_vm._s(_vm.supposeCreditDesc))]), _vm._v(" "), _c('div', {
    staticClass: "credit_calculate_base_right"
  }, [_vm.type === 'credit' ? [_c('span', {
    staticClass: "credit_value_text"
  }, [_vm._v(_vm._s(_vm.credit))]), _vm._v(" "), _c('div', {
    staticClass: "credit_text"
  }, [_vm._v("(≈ " + _vm._s(_vm.baseCurrencyDesc) + ")")])] : [_c('span', {
    staticClass: "credit_value_text"
  }, [_vm._v("≈ " + _vm._s(_vm.baseCurrencyDesc))]), _vm._v(" "), _c('div', {
    staticClass: "credit_text"
  }, [_vm._v("(" + _vm._s(_vm.baseCreditDesc) + ")")])]], 2)])])]);
};
var __vue_staticRenderFns__$1 = [];

/* style */
var __vue_inject_styles__$1 = undefined;
/* scoped */
var __vue_scope_id__$1 = "data-v-573e1e7f";
/* module identifier */
var __vue_module_identifier__$1 = undefined;
/* functional template */
var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var LabelCreditValue = /** @class */function (_super) {
  __extends(LabelCreditValue, _super);
  function LabelCreditValue() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.visibleCreditDialog = false;
    return _this;
  }
  Object.defineProperty(LabelCreditValue.prototype, "colorAccent10", {
    get: function get() {
      return $colorAccent10;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LabelCreditValue.prototype, "colorAccent8", {
    get: function get() {
      return $colorAccent8;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LabelCreditValue.prototype, "buttonText", {
    get: function get() {
      var _a, _b;
      return ((_b = (_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.button_desc) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LabelCreditValue.prototype, "titleText", {
    get: function get() {
      var _a, _b;
      return ((_b = (_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.title) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LabelCreditValue.prototype, "currencyDesc", {
    get: function get() {
      var _a = this.creditInfo,
        currency_desc = _a.currency_desc,
        _b = _a.credit_unit_price,
        credit_unit_price = _b === void 0 ? 0 : _b,
        _c = _a.currency_frac,
        currency_frac = _c === void 0 ? 0 : _c;
      var defaultText = currency_desc;
      var defaultPrice = credit_unit_price * this.creditRate;
      return defaultText.replace('{price}', this.roundAndKeepDigits(defaultPrice, currency_frac));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LabelCreditValue.prototype, "creditDescText", {
    // 积分总数描述
    get: function get() {
      var credit_desc = this.creditInfo.credit_desc;
      return credit_desc;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LabelCreditValue.prototype, "creditDesc", {
    // 积分总数描述
    get: function get() {
      var credit_desc = this.creditInfo.credit_desc;
      return "".concat(this.creditRate, " ").concat(credit_desc);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(LabelCreditValue.prototype, "rewardsEntryDesc", {
    get: function get() {
      var _a;
      return (_a = this.componentData) === null || _a === void 0 ? void 0 : _a.rewards_entry_desc;
    },
    enumerable: false,
    configurable: true
  });
  LabelCreditValue.prototype.showCreditDetailDialog = function () {
    var _this = this;
    if (this.platform !== 'desktop') {
      this.visibleCreditDialog = true;
      if (window) {
        this.$nextTick(function () {
          var target = _this.$refs.creditDialogContent;
          _this.sendDataSpm('pageview', target, {
            LevelType: _this.levelType,
            MemberResidence: _this.membershipResidence,
            ConfirmedResidence: _this.confirmedResidence,
            EntryType: 'Label'
          });
        });
      }
      this.$emit('open-modal');
    }
  };
  LabelCreditValue.prototype.closeHandle = function () {
    this.$emit('close-modal');
  };
  LabelCreditValue.prototype.gotItHandle = function () {
    this.visibleCreditDialog = false;
    if (this.platform !== 'mobile') {
      this.$emit('close-modal');
    }
  };
  LabelCreditValue.prototype.created = function () {};
  __decorate([Prop({
    "default": {}
  })], LabelCreditValue.prototype, "poptipConfig", void 0);
  LabelCreditValue = __decorate([Component({
    components: {
      RewardEntry: __vue_component__,
      GoldCreditValue: __vue_component__$1,
      IconChevronDown: IconChevronDown,
      IconNext: IconNext,
      KlkButton: KlkButton,
      KlkBottomSheet: KlkBottomSheet,
      KlkPoptip: KlkPoptip
    }
  })], LabelCreditValue);
  return LabelCreditValue;
}(CommonMixin);

/* script */
var __vue_script__$2 = LabelCreditValue;
/* template */
var __vue_render__$2 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "simple-credit-value-box"
  }, [_c(_vm.platform === 'desktop' ? 'klk-poptip' : 'div', _vm._b({
    tag: "component",
    attrs: {
      "defaultPoptipOptions": "{"
    }
  }, 'component', _vm.platform === 'desktop' ? Object.assign({}, {
    placement: 'bottom'
  }, _vm.defaultPoptipOptions, _vm.poptipConfig) : {}, false), [_c('div', {
    staticClass: "simple_credit_value_btn",
    "class": (_vm.is3X ? 'credit3x' : 'normal') + " simple_credit_" + _vm.platform + "_layout",
    attrs: {
      "data-spm-module": "CreditsEntry?ext=" + JSON.stringify({
        LevelType: _vm.levelType,
        MemberResidence: _vm.membershipResidence,
        ConfirmedResidence: _vm.confirmedResidence,
        EntryType: 'Label'
      }),
      "data-spm-virtual-item": "__virtual"
    },
    on: {
      "click": _vm.showCreditDetailDialog
    }
  }, [_vm.is3X ? _c('div', {
    staticClass: "credit_3x_currency_icon",
    "class": "credit_3x_currency_" + _vm.platform + "_icon",
    style: "background-image:url(" + (_vm.platform == 'desktop' ? _vm.currencyLabelDesktop3XIcon : _vm.currencyLabelMobile3XIcon) + ")"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "credit_desc_box",
    "class": _vm.is3X ? 'gold_layout' : 'explorer_layout'
  }, [_c('span', {
    staticClass: "credit_desc_text"
  }, [_vm._v(_vm._s(_vm.creditDescText))]), _vm._v(" "), _c('span', {
    staticClass: "credit_text"
  }, [_vm._v("+" + _vm._s(_vm.creditRate))])]), _vm._v(" "), _vm.platform === 'mobile' ? _c('IconNext', {
    attrs: {
      "theme": "outline",
      "size": "16",
      "fill": _vm.is3X ? _vm.colorAccent10 : _vm.colorAccent8
    }
  }) : _c('IconChevronDown', {
    attrs: {
      "theme": "outline",
      "size": "16",
      "fill": _vm.is3X ? _vm.colorAccent10 : _vm.colorAccent8
    }
  })], 1), _vm._v(" "), _vm.platform === 'desktop' ? _c('div', {
    staticClass: "credit-dialog-content-box credit_label_content_poptip_layout",
    attrs: {
      "slot": "content",
      "data-spm-page": "CreditsDetailPopup?ext=" + JSON.stringify({
        LevelType: _vm.levelType,
        MemberResidence: _vm.membershipResidence,
        ConfirmedResidence: _vm.confirmedResidence,
        EntryType: 'Label'
      })
    },
    slot: "content"
  }, [_vm.is3X ? [_c('GoldCreditValue', {
    attrs: {
      "credit": _vm.credit,
      "member-credit-info": _vm.memberCreditInfo,
      "webp": _vm.webp,
      "type": "credit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "credit_count_desc credit_count_desc_mweb_layout"
  }, [_vm._v("\n          " + _vm._s(_vm.subDesc) + "\n        ")])] : [_c('div', {
    staticClass: "credit_value_title"
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    staticClass: "credit_value_desc"
  }, [_vm._v(_vm._s(_vm.countDesc))]), _vm._v(" "), _c('div', {
    staticClass: "credit_currency_desc_poptip_layout normal"
  }, [_c('div', {
    staticClass: "credit_currency_desc_text"
  }, [_c('span', {
    staticClass: "currency_text"
  }, [_vm._v(_vm._s(_vm.credit))]), _vm._v(" "), _c('span', {
    staticClass: "credit_text"
  }, [_vm._v("(≈ " + _vm._s(_vm.currencyDesc) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "credit_count_desc"
  }, [_vm._v(_vm._s(_vm.subDesc))]), _vm._v(" "), _c('RewardEntry', {
    staticClass: "reward-entry",
    attrs: {
      "visible-reward-entry": _vm.visibleRewardEntry,
      "member-credit-info": _vm.memberCreditInfo,
      "webp": _vm.webp
    }
  })]], 2) : _vm._e()]), _vm._v(" "), _c('klk-bottom-sheet', {
    staticClass: "simple_credit-dialog",
    attrs: {
      "visible": _vm.visibleCreditDialog,
      "title": _vm.titleText,
      "show-close": _vm.platform === 'mobile',
      "transfer": _vm.platform === 'mobile',
      "closable": _vm.platform !== 'mobile',
      "open": _vm.visibleCreditDialog,
      "overlay-closable": _vm.platform !== 'mobile',
      "show-default-footer": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visibleCreditDialog = $event;
      },
      "update:open": function updateOpen($event) {
        _vm.visibleCreditDialog = $event;
      },
      "close": _vm.closeHandle
    }
  }, [_c('div', {
    ref: "creditDialogContent",
    staticClass: "credit-dialog-content-box",
    attrs: {
      "data-spm-page": "CreditsDetailPopup?trg=manual&ext=" + JSON.stringify({
        LevelType: _vm.levelType,
        MemberResidence: _vm.membershipResidence,
        ConfirmedResidence: _vm.confirmedResidence,
        EntryType: 'Label'
      })
    }
  }, [_vm.is3X ? [_c('GoldCreditValue', {
    attrs: {
      "credit": _vm.credit,
      "member-credit-info": _vm.memberCreditInfo,
      "webp": _vm.webp,
      "type": "credit"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "credit_count_desc credit_count_desc_mweb_layout"
  }, [_vm._v("\n          " + _vm._s(_vm.subDesc) + "\n        ")])] : [_c('div', {
    staticClass: "credit_value_desc"
  }, [_vm._v(_vm._s(_vm.countDesc))]), _vm._v(" "), _c('div', {
    staticClass: "credit_currency_desc normal"
  }, [_c('div', {
    staticClass: "credit_currency_desc_text"
  }, [_c('span', {
    staticClass: "currency_text"
  }, [_vm._v(" " + _vm._s(_vm.credit) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "credit_text"
  }, [_vm._v(" (≈ " + _vm._s(_vm.currencyDesc) + ") ")])])]), _vm._v(" "), _c('div', {
    staticClass: "credit_count_desc"
  }, [_vm._v(_vm._s(_vm.subDesc))]), _vm._v(" "), _c('RewardEntry', {
    staticClass: "reward-entry",
    attrs: {
      "visible-reward-entry": _vm.visibleRewardEntry,
      "member-credit-info": _vm.memberCreditInfo,
      "webp": _vm.webp
    }
  })], _vm._v(" "), _c('klk-button', {
    staticClass: "got_it_btn",
    attrs: {
      "data-spm-module": "GotIt",
      "data-spm-virtual-item": "__virtual",
      "type": "primary",
      "block": ""
    },
    on: {
      "click": _vm.gotItHandle
    }
  }, [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n      ")])], 2)])], 1);
};
var __vue_staticRenderFns__$2 = [];

/* style */
var __vue_inject_styles__$2 = undefined;
/* scoped */
var __vue_scope_id__$2 = "data-v-1e557d02";
/* module identifier */
var __vue_module_identifier__$2 = undefined;
/* functional template */
var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

var NormalCreditValue$2 = /** @class */function (_super) {
  __extends(NormalCreditValue, _super);
  function NormalCreditValue() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.visibleDescBottomSheet = false;
    return _this;
  }
  Object.defineProperty(NormalCreditValue.prototype, "colorAccent10", {
    get: function get() {
      return $colorAccent10;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "buttonText", {
    get: function get() {
      var _a, _b;
      return ((_b = (_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.button_desc) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "titleText", {
    get: function get() {
      var _a, _b;
      return ((_b = (_a = this.creditInfo) === null || _a === void 0 ? void 0 : _a.component) === null || _b === void 0 ? void 0 : _b.title) || '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "currencyDesc", {
    get: function get() {
      var _a = this.creditInfo,
        currency_desc = _a.currency_desc,
        _b = _a.credit_unit_price,
        credit_unit_price = _b === void 0 ? 0 : _b,
        _c = _a.currency_frac,
        currency_frac = _c === void 0 ? 0 : _c;
      var defaultText = currency_desc;
      var defaultPrice = credit_unit_price * this.creditRate;
      return defaultText.replace('{price}', this.roundAndKeepDigits(defaultPrice, currency_frac));
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "creditCurrencyDescSpmData", {
    get: function get() {
      return this.is3X ? {
        'data-spm-module': "CreditsEntry?ext=".concat(JSON.stringify({
          LevelType: this.levelType,
          MemberResidence: this.membershipResidence,
          ConfirmedResidence: this.confirmedResidence,
          EntryType: 'Card'
        })),
        'data-spm-virtual-item': '__virtual'
      } : {};
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "creditDesc", {
    // 积分总数描述
    get: function get() {
      var credit_desc = this.creditInfo.credit_desc;
      return "".concat(this.creditRate, " ").concat(credit_desc);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(NormalCreditValue.prototype, "rewardsEntryDesc", {
    get: function get() {
      var _a;
      return (_a = this.componentData) === null || _a === void 0 ? void 0 : _a.rewards_entry_desc;
    },
    enumerable: false,
    configurable: true
  });
  NormalCreditValue.prototype.show3XCreditDesc = function () {
    if (!this.is3X || this.platform !== 'mobile') {
      return;
    }
    this.visibleDescBottomSheet = true;
    this.$emit('open-modal');
  };
  NormalCreditValue.prototype.closeHandle = function () {
    this.$emit('close-modal');
  };
  NormalCreditValue.prototype.getItHandle = function () {
    this.visibleDescBottomSheet = false;
  };
  NormalCreditValue.prototype.created = function () {};
  __decorate([Prop({
    "default": {}
  })], NormalCreditValue.prototype, "poptipConfig", void 0);
  NormalCreditValue = __decorate([Component({
    components: {
      RewardEntry: __vue_component__,
      GoldCreditValue: __vue_component__$1,
      IconChevronDown: IconChevronDown,
      KlkButton: KlkButton,
      KlkBottomSheet: KlkBottomSheet,
      KlkPoptip: KlkPoptip
    }
  })], NormalCreditValue);
  return NormalCreditValue;
}(CommonMixin);

/* script */
var __vue_script__$3 = NormalCreditValue$2;
/* template */
var __vue_render__$3 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.creditRate >= _vm.visibleMinCredit ? _c('div', {
    staticClass: "normal-credit-value-box",
    attrs: {
      "data-spm-module": "CreditsDetail?ext=" + JSON.stringify({
        LevelType: _vm.levelType,
        MemberResidence: _vm.membershipResidence,
        ConfirmedResidence: _vm.confirmedResidence,
        EntryType: 'Card'
      })
    }
  }, [_c('div', {
    staticClass: "credit_value_title"
  }, [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('div', {
    staticClass: "credit_value_desc"
  }, [_vm._v(_vm._s(_vm.valueDesc))]), _vm._v(" "), _c(_vm.platform === 'desktop' && _vm.is3X ? 'klk-poptip' : 'div', _vm._b({
    tag: "component"
  }, 'component', Object.assign({}, {
    placement: 'bottom'
  }, _vm.platform === 'desktop' && _vm.is3X ? Object.assign({}, _vm.defaultPoptipOptions, _vm.poptipConfig) : Object.assign({}, _vm.defaultPoptipOptions)), false), [_c('div', _vm._b({
    staticClass: "credit_currency_desc",
    "class": _vm.is3X ? 'credit3x' : 'normal',
    on: {
      "click": _vm.show3XCreditDesc
    }
  }, 'div', _vm.creditCurrencyDescSpmData, false), [_vm.is3X ? _c('div', {
    staticClass: "credit_3x_currency_icon",
    style: "background-image:url(" + _vm.currencyCard3XIcon + ")"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "credit_currency_desc_text"
  }, [_c('span', {
    staticClass: "currency_text"
  }, [_vm._v("≈ " + _vm._s(_vm.currencyDesc))]), _vm._v(" "), _c('span', {
    staticClass: "credit_text"
  }, [_vm._v("(" + _vm._s(_vm.creditDesc) + ")")])]), _vm._v(" "), _vm.is3X ? _c('IconChevronDown', {
    staticClass: "down_icon",
    attrs: {
      "theme": "outline",
      "size": "20",
      "fill": _vm.colorAccent10
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.platform === 'desktop' && _vm.is3X ? _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('GoldCreditValue', {
    attrs: {
      "credit": _vm.credit,
      "member-credit-info": _vm.memberCreditInfo,
      "webp": _vm.webp
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "credit_count_desc"
  }, [_vm._v(_vm._s(_vm.subDesc))]), _vm._v(" "), _c('RewardEntry', {
    staticClass: "reward-entry",
    attrs: {
      "visible-reward-entry": _vm.visibleRewardEntry,
      "member-credit-info": _vm.memberCreditInfo,
      "webp": _vm.webp
    }
  }), _vm._v(" "), _vm.platform === 'mobile' ? [_c('klk-bottom-sheet', {
    staticClass: "normal_credit-dialog",
    attrs: {
      "visible": _vm.visibleDescBottomSheet,
      "title": _vm.titleText,
      "show-close": "",
      "transfer": true
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visibleDescBottomSheet = $event;
      },
      "close": _vm.closeHandle
    }
  }, [_c('div', {
    staticClass: "normal_credit-dialog_content_box"
  }, [_c('GoldCreditValue', {
    attrs: {
      "credit": _vm.credit,
      "member-credit-info": _vm.memberCreditInfo,
      "webp": _vm.webp
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "credit_count_desc credit_count_desc_mweb_layout"
  }, [_vm._v("\n          " + _vm._s(_vm.subDesc) + "\n        ")]), _vm._v(" "), _c('klk-button', {
    staticClass: "got_it_btn",
    attrs: {
      "type": "primary",
      "block": ""
    },
    on: {
      "click": _vm.getItHandle
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonText) + "\n        ")])], 1)])] : _vm._e()], 2) : _vm._e();
};
var __vue_staticRenderFns__$3 = [];

/* style */
var __vue_inject_styles__$3 = undefined;
/* scoped */
var __vue_scope_id__$3 = "data-v-03b5f2c4";
/* module identifier */
var __vue_module_identifier__$3 = undefined;
/* functional template */
var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

var KlkMemberCreditValue = /** @class */function (_super) {
  __extends(KlkMemberCreditValue, _super);
  function KlkMemberCreditValue() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.memberCreditInfo = null;
    _this.inited = false;
    return _this;
  }
  Object.defineProperty(KlkMemberCreditValue.prototype, "_axios", {
    get: function get() {
      return this.axios || this.$axios || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(KlkMemberCreditValue.prototype, "_state", {
    get: function get() {
      var _a;
      return ((_a = this === null || this === void 0 ? void 0 : this.$store) === null || _a === void 0 ? void 0 : _a.state) || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(KlkMemberCreditValue.prototype, "_platform", {
    get: function get() {
      var _a, _b;
      return this.platform || ((_b = (_a = this._state) === null || _a === void 0 ? void 0 : _a.klook) === null || _b === void 0 ? void 0 : _b.platform) || 'desktop';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(KlkMemberCreditValue.prototype, "user", {
    get: function get() {
      var _a, _b;
      return ((_b = (_a = this._state) === null || _a === void 0 ? void 0 : _a.auth) === null || _b === void 0 ? void 0 : _b.user) || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(KlkMemberCreditValue.prototype, "_userInfo", {
    get: function get() {
      return this.userInfo || this.user || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(KlkMemberCreditValue.prototype, "$colorTextPrimary", {
    get: function get() {
      return $colorTextPrimary;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(KlkMemberCreditValue.prototype, "userId", {
    get: function get() {
      var _a;
      return ((_a = this._userInfo) === null || _a === void 0 ? void 0 : _a.id) || '';
    },
    enumerable: false,
    configurable: true
  });
  KlkMemberCreditValue.prototype.creditChangeRefresh = function (val, oldVal) {
    if (+val !== +oldVal) {
      this.getMemberCreditInfoData();
    }
  };
  KlkMemberCreditValue.prototype.onReloadMemberInfo = function (val, oldVal) {
    if (+val !== +oldVal) {
      this.getMemberCreditInfoData();
    }
  };
  KlkMemberCreditValue.prototype.getMemberCreditInfoData = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, this._axios.$get('/v3/userserv/user/bff_service/get_membership_credit_component_info')];
          case 1:
            res = _a.sent();
            if ((res === null || res === void 0 ? void 0 : res.success) && res.result) {
              this.memberCreditInfo = res.result;
            }
            this.inited = true;
            return [2 /*return*/];
        }
      });
    });
  };

  __decorate([Prop({
    "default": 0
  })], KlkMemberCreditValue.prototype, "credit", void 0);
  __decorate([Prop({
    "default": 'card'
  })], KlkMemberCreditValue.prototype, "type", void 0);
  __decorate([Prop({
    "default": true
  })], KlkMemberCreditValue.prototype, "visibleRewardEntry", void 0);
  __decorate([Prop({
    "default": ''
  })], KlkMemberCreditValue.prototype, "platform", void 0);
  __decorate([Prop({
    "default": null
  })], KlkMemberCreditValue.prototype, "userInfo", void 0);
  __decorate([Prop({
    type: Number,
    "default": undefined
  })], KlkMemberCreditValue.prototype, "webp", void 0);
  __decorate([Prop()], KlkMemberCreditValue.prototype, "axios", void 0);
  __decorate([Prop()], KlkMemberCreditValue.prototype, "inhouse", void 0);
  __decorate([Prop({
    "default": function _default() {
      return {};
    }
  })], KlkMemberCreditValue.prototype, "poptipConfig", void 0);
  __decorate([Prop({
    type: Number,
    "default": 10
  })], KlkMemberCreditValue.prototype, "visibleMinCredit", void 0);
  __decorate([Watch('credit', {
    immediate: true
  })], KlkMemberCreditValue.prototype, "creditChangeRefresh", null);
  __decorate([Watch('userId')], KlkMemberCreditValue.prototype, "onReloadMemberInfo", null);
  KlkMemberCreditValue = __decorate([Component({
    components: {
      CardCredit: __vue_component__$3,
      LabelCredit: __vue_component__$2
    }
  })], KlkMemberCreditValue);
  return KlkMemberCreditValue;
}(Vue);

/* script */
var __vue_script__$4 = KlkMemberCreditValue;
/* template */
var __vue_render__$4 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "klk-credit-member-value-box",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.inited && _vm.credit > 0 ? [_vm.type === 'label' ? _c('LabelCredit', _vm._g({
    attrs: {
      "webp": _vm.webp,
      "credit": _vm.credit,
      "member-credit-info": _vm.memberCreditInfo,
      "visible-reward-entry": _vm.visibleRewardEntry,
      "platform": _vm._platform,
      "poptip-config": _vm.poptipConfig,
      "inhouse": _vm.inhouse
    }
  }, _vm.$listeners)) : _c('card-credit', _vm._g({
    attrs: {
      "webp": _vm.webp,
      "credit": _vm.credit,
      "member-credit-info": _vm.memberCreditInfo,
      "visible-reward-entry": _vm.visibleRewardEntry,
      "platform": _vm._platform,
      "poptip-config": _vm.poptipConfig,
      "visible-min-credit": _vm.visibleMinCredit,
      "inhouse": _vm.inhouse
    }
  }, _vm.$listeners))] : _vm._e()], 2);
};
var __vue_staticRenderFns__$4 = [];

/* style */
var __vue_inject_styles__$4 = undefined;
/* scoped */
var __vue_scope_id__$4 = "data-v-077d3d9e";
/* module identifier */
var __vue_module_identifier__$4 = undefined;
/* functional template */
var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

// @ts-ignore
__vue_component__$4.install = function (Vue) {
  Vue.component('klkMemebrCreditValue', __vue_component__$4);
};

export default __vue_component__$4;
